import React, { useState } from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import { getParticipantById, getParticipantDisplayName, isLocalParticipantModerator } from '../../../base/participants';
import { hideDialog } from '../../../base/dialog/actions';
import { sendCommand } from '../../../mod-command/slice';
import { COMMANDS } from '../../../mod-command/constants';
import { isBannedChangeName } from '../../../changename-moderation/functions';
import { approveParticipantChangeName, rejectParticipantChangeName } from '../../../changename-moderation/slice';
import { InputAdornment, TextField } from '@mui/material';
import ClickableIcon from '../../../base/ui/components/web/ClickableIcon';
import { Trans } from 'react-i18next';
const IconRemove = () => {
    return (React.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5 3.82107L8.53553 0.285534L9.71405 1.46405L6.17851 4.99958L9.71405 8.53511L8.53553 9.71362L5 6.17809L1.46447 9.71362L0.285955 8.53511L3.82149 4.99958L0.285955 1.46405L1.46447 0.285534L5 3.82107Z", fill: "#8F9294" })));
};
/**
 * Dialog to confirm a remote participant kick action.
 */
const ChangeNameOtherDialog = (props) => {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    const state = APP.store.getState();
    const isOwner = isLocalParticipantModerator(state);
    const displayName = getParticipantDisplayName(state, props.participantID);
    const title = props.t('dialog.changeNameParticipantTitle', { memberChangeName: displayName });
    const [error, setError] = useState('');
    const [newName, setNewName] = useState(displayName);
    // const valid = /[^0-9a-zA-Z-_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ ]+/g;
    const _onSubmit = () => {
        if (isOwner && newName.trim() !== '' && newName.trim()?.length < 65) {
            const newNameTrimSpace = newName.trim().replace(/\s\s+/g, ' ');
            const objValue = { id: props.participantID, newName: newNameTrimSpace };
            const objValueString = JSON.stringify(objValue);
            const participant = getParticipantById(state, props.participantID ?? '');
            if (participant) {
                if (isBannedChangeName(participant, state)) {
                    props.dispatch(approveParticipantChangeName(props.participantID));
                    setTimeout(() => {
                        props.dispatch(rejectParticipantChangeName(props.participantID));
                    }, 300);
                }
                props.dispatch(sendCommand(COMMANDS.CHANGE_NAME.COMMAND, objValueString, false));
            }
        }
        props.dispatch(hideDialog(ChangeNameOtherDialog));
    };
    return (React.createElement(Dialog, { ok: { translationKey: 'dialog.changeNameParticipantButton', disabled: (newName.trim()?.length > 64) || (newName.trim() === '') }, onSubmit: _onSubmit, title: title },
        React.createElement("div", null,
            React.createElement(Trans, { i18nKey: "dialog.descChangeNameParticipantTitle", values: { name: displayName } })),
        React.createElement("div", { style: { marginBottom: '6px' } },
            props.t('dialog.setDisplayNameLabel'),
            React.createElement("span", { style: { color: "#ee0033" } }, "*")),
        React.createElement("div", { style: { marginBottom: '16px' } },
            React.createElement(TextField, { sx: {
                    fontSize: '14px',
                    padding: '0px',
                    width: '100%',
                    '& .MuiInputBase-root': {
                        height: '32px',
                        paddingRight: '0px !important',
                        '& input': {
                            padding: '8px 0 8px 16px !important',
                            fontSize: '14px !important'
                        },
                        "&.Mui-focused": {
                            borderColor: 'red',
                        },
                    }
                }, autoFocus: true, value: newName ?? "", onChange: (event) => {
                    if (event.target.value.trim() === "") {
                        setError(props.t('menuController.validateDisplayNameRequired'));
                    }
                    else if (event.target.value.trim().length > 64) {
                        setError(props.t('menuController.validateDisplayNameLength'));
                    }
                    else {
                        setError("");
                    }
                    setNewName(event.target.value);
                }, error: !!error?.length, InputProps: {
                    endAdornment: (React.createElement(InputAdornment, { position: "end" }, (newName.trim() ?? "")?.length > 0 ? (React.createElement("div", { style: { padding: '4px' } },
                        React.createElement(ClickableIcon, { accessibilityLabel: "close", icon: IconRemove, onClick: () => {
                                setError(props.t('menuController.validateDisplayNameRequired'));
                                setNewName('');
                            } }))) : (React.createElement(React.Fragment, null)))),
                } }),
            error && (React.createElement("div", { style: { color: '#EE0033', fontSize: '14px', position: "absolute" } }, error)))));
};
export default translate(connect()(ChangeNameOtherDialog));
